import { createUseStyles } from 'react-jss';

export default createUseStyles({
  settingRow: {
    display: 'flex',
    alignItems: 'center'
  }
});
